import { Language } from '@models/Sessions/Idea/language';

export const languages: Language[] = [
  { name: 'Bulgarian', code: 'BG' },
  { name: 'Czech', code: 'CS' },
  { name: 'Danish', code: 'DA' },
  { name: 'German', code: 'DE' },
  { name: 'Greek', code: 'EL' },
  { name: 'English (United Kingdom)', code: 'EN-GB' },
  { name: 'English (United States)', code: 'EN-US' },
  { name: 'Spanish', code: 'ES' },
  { name: 'Estonian', code: 'ET' },
  { name: 'Finnish', code: 'FI' },
  { name: 'French', code: 'FR' },
  { name: 'Hungarian', code: 'HU' },
  { name: 'Indonesian', code: 'ID' },
  { name: 'Italian', code: 'IT' },
  { name: 'Japanese', code: 'JA' },
  { name: 'Korean', code: 'KO' },
  { name: 'Lithuanian', code: 'LT' },
  { name: 'Latvian', code: 'LV' },
  { name: 'Norwegian', code: 'NB' },
  { name: 'Dutch', code: 'NL' },
  { name: 'Polish', code: 'PL' },
  { name: 'Portuguese (Brazil)', code: 'PT-BR' },
  { name: 'Portuguese (Portugal)', code: 'PT-PT' },
  { name: 'Romanian', code: 'RO' },
  { name: 'Russian', code: 'RU' },
  { name: 'Slovak', code: 'SK' },
  { name: 'Slovenian', code: 'SL' },
  { name: 'Swedish', code: 'SV' },
  { name: 'Turkish', code: 'TR' },
  { name: 'Ukrainian', code: 'UK' },
  { name: 'Chinese', code: 'ZH' },
  { name: 'Chinese (Simplified)', code: 'ZH-HANS' },
];
